import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';


const tryToFetchHistoryChats = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/users/chat-history`);
};

export const HistoryChatsService = {
    tryToFetchHistoryChats,
};